export default `
## Technical Skills

**Languages**

- Go, JavaScript (Node.js), Kotlin, Python, SQL

**Frontend**

- React, Vue.js

**Infrastructure & Cloud**

- Kubernetes, Docker, Terraform, AWS, Cloudflare

**Distributed Systems & Architecture**

- Microservices, REST APIs, CDN/Edge Delivery

**AI & Platform Engineering**

- AI-Driven Application Platforms, LLM-Integrated Application Design

**Observability**

- Datadog, Sentry

---

## Awards

> The Eisenberg Award — University of Washington Informatics. Recognized for exceptional leadership and impact within the program.

`;

